/* eslint-disable */

/** Customer preference on how to deal with incoming payments. */
export enum DepositPreference {
  /**
   * TRANSFER_IMMEDIATELY - Incoming funds are immediately transferred to the customer's debit card or bank account.
   * This is only applicable for customers that are eligible for free instant deposits.
   */
  TRANSFER_IMMEDIATELY = "TRANSFER_IMMEDIATELY",
  /** RETAIN_FUNDS_IN_CASH_BALANCE - Incoming funds are moved to Customer's Cash balance. */
  RETAIN_FUNDS_IN_CASH_BALANCE = "RETAIN_FUNDS_IN_CASH_BALANCE",
  /**
   * TRANSFER_INSTANTLY_WITH_FEE - Incoming funds are instantly transferred to the customer's debit card for the fee described
   * by the DepositFeeData.
   */
  TRANSFER_INSTANTLY_WITH_FEE = "TRANSFER_INSTANTLY_WITH_FEE",
  /** TRANSFER_SLOWLY_WITHOUT_FEE - Incoming funds are transferred to the customer's debit card or bank account slowly for free. */
  TRANSFER_SLOWLY_WITHOUT_FEE = "TRANSFER_SLOWLY_WITHOUT_FEE",
  /** TRANSFER_SLOWLY_WITH_FEE - Incoming funds are transferred to the business customer's account slowly for a fee. */
  TRANSFER_SLOWLY_WITH_FEE = "TRANSFER_SLOWLY_WITH_FEE",
}
